const logEnabled = false;

export const logEvent = <T>(name: string, additional?: () => T) => <E>(ev: E) => {
    if (logEnabled) {
        console.log(name, ev, additional ? additional() : undefined);
    }
};
